import { langs } from '@utils/helpers'

// Process
let processProperties = []; 
Object.keys(langs).forEach(langCode => {
    processProperties.push({
        "name": "name-" + langCode,
        "isAttr": true,
        "type": "String"
    });
    processProperties.push({
        "name": "documentation-" + langCode,
        "isAttr": false,
        "type": "String"
    });
});

// Message
let messageProperties = [{
    "name": "type",
    "isAttr": true,
    "type": "String"
}, {
    "name": "recipient",
    "isAttr": true,
    "type": "String"
}, {
    "name": "email",
    "isAttr": true,
    "type": "String"
}, {
    "name": "message-json",
    "isAttr": false,
    "type": "String"
}, {
    "name": "send-form",
    "isAttr": true,
    "type": "String"
}, {
    "name": "form-json",
    "isAttr": false,
    "type": "String"
}];


// Flux (Condition)
let flowProperties = [{
    "name": "type",
    "isAttr": true,
    "type": "String"
}, {
    "name": "field",
    "isAttr": true,
    "type": "String"
}, {
    "name": "condition",
    "isAttr": true,
    "type": "String"
}, {
    "name": "value",
    "isAttr": true,
    "type": "String"
}, {
    // Trigger delay
    "name": "delay",
    "isAttr": true,
    "type": "String" // Durée ISO 8601, exemple : P2DT3H (2 jours et 3 heures)
}];

// External Service
let externalServiceProperties = [{
    "name": "action",
    "isAttr": true,
    "type": "String"
}, {
    "name": "label",
    "isAttr": false,
    "type": "String"
}, {
    "name": "type",
    "isAttr": true,
    "type": "String"
}, {
    "name": "params-json",
    "isAttr": false,
    "type": "String"
}];

const AktorModdleDescriptor = {
    "name": "Aktor",
    "prefix": "aktor",
    "uri": "http://aktor",
    "xml": {
        "tagAlias": "lowerCase"
    },
    "associations": [],
    "types": [
        {
            "name": "MultilangProcess",
            "extends": [
                "bpmn:Process"
            ],
            "properties": processProperties
        },
        {
            "name": "Message",
            "extends": [
                "bpmn:SendTask"
            ],
            "properties": messageProperties
        },
        {
            "name": "Flow",
            "extends": [
                "bpmn:SequenceFlow"
            ],
            "properties": flowProperties
        },
        {
            "name": "ExternalService",
            "extends": [
                "bpmn:ServiceTask"
            ],
            "properties": externalServiceProperties
        }
    ]
};

export default AktorModdleDescriptor;